// extracted by mini-css-extract-plugin
module.exports = {"container":"PluginNonInstalled_container__d2VQj","icon":"PluginNonInstalled_icon__1WUpS"};